module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/FINE ART-e25ffa466064121b912d213629c635f3.png";